import { FC } from 'react'
import { UseFormGetValues } from 'react-hook-form'

import { RegStep, FormValues, FieldId } from '../../data'
import { FieldsNameVoc } from 'constants/auth/profile-data'
import { A_signinProgress, stepRegProgress } from 'utils/analytics/other/registration/registration'

import styles from './enter-email-btn.module.scss'

interface IEnterEmail {
  setStep: React.Dispatch<React.SetStateAction<RegStep>>
  getValues: UseFormGetValues<FormValues>
}

const EnterEmail: FC<IEnterEmail> = ({ setStep, getValues }) => {
  const isDBUser = getValues()[FieldId]
  const email = getValues()[FieldsNameVoc.email]
  const clickHandler = () => {
    isDBUser || email ? setStep(RegStep.EMAIL_FLOW_OK) : setStep(RegStep.EMAIL_WIDGET)
    A_signinProgress(stepRegProgress.EMAIL_CLICK)
  }
  return (
    <div className={styles.btn} onClick={clickHandler}>
      Войти по почте
    </div>
  )
}

export default EnterEmail
